import { render, staticRenderFns } from "./bookingscompletetable.vue?vue&type=template&id=1ce225b3&scoped=true&"
import script from "./bookingscompletetable.vue?vue&type=script&lang=js&"
export * from "./bookingscompletetable.vue?vue&type=script&lang=js&"
import style0 from "./bookingscompletetable.vue?vue&type=style&index=0&id=1ce225b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce225b3",
  null
  
)

export default component.exports